import { useEffect } from 'react';
import { WorkflowType } from '../enums';

/*
  Replaces the browser url as the workflow id and/or workflowType changes as we are switching between the draft and published workflow types
 */

export const useUpdateJourneyUrl = (id?: string, workflowType?: WorkflowType) => {
  useEffect(() => {
    if (id && workflowType) {
      const url = new URL(window.location.href);
      url.searchParams.set('workflowType', workflowType);
      url.pathname = url.pathname.replace(/\workflows\/(\d+)/, `workflows/${id}`);
      window.history.replaceState({}, '', url.toString());
    }
  }, [id, workflowType]);
};
